import styled from 'styled-components';

export const ListContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #ccc;
  padding: 12px;
`;
